import React from 'react';
import { Button, Select, MenuItem, FormControl, InputLabel, Box, Grid2 as Grid } from '@mui/material';
import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { createList } from './listService';
import { useEffect } from 'react';

function Search() {
    const [treeType, setTreeType] = React.useState('');
    const [treeSize, setTreeSize] = React.useState('');

    const queryParams = new URLSearchParams(window.location.search);
    const treeTypeParam = queryParams.get('treetype');

    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const category = `${treeType}-${treeSize}`;

    const createProductListMutation = useMutation(
        () => createList(category),
        {
            onSuccess: (productList) => {
                queryClient.invalidateQueries({ queryKey: ['lists'] });
                navigate('/lists/' + productList.id + '/swipe');
            },
            onError: (error) => {
                console.error('Failed to fetch product lists:', error);
            }
        }
    );

    const handleTypeChange = (event) => {
        setTreeType(event.target.value);
    };

    const handleSizeChange = (event) => {
        setTreeSize(event.target.value);
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        createProductListMutation.mutate();
    }

    useEffect(() => {
        if (treeTypeParam) {
            setTreeType(treeTypeParam);
        }
    }, [treeTypeParam]);

    return (
        <Box component="form" onSubmit={handleSubmit} textAlign="center">
            <Grid container spacing={2} justifyContent="center">
                <Grid item xs={12} sm={6}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel>Fenyőfa fajtája</InputLabel>
                        <Select
                            required
                            value={treeType}
                            onChange={handleTypeChange}
                            label="Fenyőfa fajtája"
                            sx={{ width: 200}}
                            MenuProps={{ disablePortal: true }}
                        >
                            <MenuItem value="nordmann">Nordmann</MenuItem>
                            <MenuItem value="ezust">Ezüst</MenuItem>
                            <MenuItem value="luc">Luc</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel>Fenyőfa mérete</InputLabel>
                        <Select
                            required
                            value={treeSize}
                            onChange={handleSizeChange}
                            label="Fenyőfa mérete"
                            sx={{ width: 200}}
                            MenuProps={{ disablePortal: true }}
                        >
                            <MenuItem value="150">150 cm-ig</MenuItem>
                            <MenuItem value="150-200">150-200 cm</MenuItem>
                            <MenuItem value="200-felett">200 cm felett</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <Button variant="contained" color="primary" type="submit" sx={{ marginTop: 2 }}>
                ÚJ KERESÉS INDÍTÁSA
            </Button>
        </Box>
    );
}

export default Search;
